var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "single-images__content-wrapper" },
    [
      _vm._l(_vm.currentVariation.images.all, function(image, key) {
        return _c(
          "div",
          {
            staticClass: "single-images__img-wrapper",
            class: {
              "single-images__img-wrapper--full-width":
                !(_vm.currentVariation.images.all.length % 2) &&
                (key === 0 ||
                  key === _vm.currentVariation.images.all.length - 1)
            },
            attrs: { "data-order": key + 1 }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  href: image.url,
                  "data-lightbox": "single-item-image" + _vm._uid
                }
              },
              [_c("img", { attrs: { src: image.url, alt: "" } })]
            )
          ]
        )
      }),
      _vm._v(" "),
      _vm.video !== ""
        ? _c(
            "div",
            {
              staticClass:
                "single-images__img-wrapper single-images__img-wrapper--full-width single-images__img-wrapper--video",
              attrs: { "data-order": "3" }
            },
            [
              _vm.videoThumb !== ""
                ? _c("video", {
                    attrs: {
                      preload: "none",
                      poster: _vm.videoThumb,
                      src: _vm.video,
                      controls: ""
                    }
                  })
                : _c("video", {
                    attrs: { preload: "metadata", src: _vm.video, controls: "" }
                  })
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }